module.exports = __webpack_public_path__ + "static/media/eaglebg.6b6d9edd.jpg";